(() => {
  const root = document.documentElement;
  const path = window.location.pathname.replace(/\/+$/, '') || '/';
  const query = new URLSearchParams(window.location.search);
  const targetVersion = query.get('seriva_typography_version') === 'v1' ? 'v1' : 'v11';

  if (query.get('seriva_typography') === 'current') return;

  root.classList.add('seriva-typography-target', `seriva-typography-target--${targetVersion}`);

  let targetScope = 'general';
  if (path === '/') {
    targetScope = 'home';
  } else if (path === '/products/seriva-five-peptide-scalp-serum') {
    targetScope = 'serum';
    root.classList.add('seriva-typography-target--product');
  } else if (path.startsWith('/products/')) {
    targetScope = 'supporting-pdp';
    root.classList.add('seriva-typography-target--product');
  } else if (path === '/collections' || path.startsWith('/collections/')) {
    targetScope = 'collection';
  } else if (path === '/cart') {
    targetScope = 'cart';
  } else if (path === '/search') {
    targetScope = 'search';
  }
  root.classList.add(`seriva-typography-target--${targetScope}`);

  const productNamePresentation = new Map([
    ['FIVE-PEPTIDE SCALP SERUM', 'Five-Peptide Scalp Serum'],
    ['SCALP RESET EXFOLIANT', 'Scalp Reset Exfoliant'],
    ['ROOT-LIFTING KERATIN SHAMPOO', 'Root-Lifting Keratin Shampoo'],
    ['SMOOTHING KERATIN CONDITIONER', 'Smoothing Keratin Conditioner'],
    ['RESTORATIVE WHEAT PROTEIN HAIR MASK', 'Restorative Wheat Protein Hair Mask'],
    ['LIGHTWEIGHT SMOOTHING LEAVE-IN MIST', 'Lightweight Smoothing Leave-In Mist'],
    ['LIGHTWEIGHT LEAVE-IN MIST', 'Lightweight Leave-In Mist'],
  ]);

  const headingPresentation = new Map([
    ['RESULTS AFTER 12 WEEKS', 'Results after 12 weeks'],
    ['RESULTS AFTER ONE USE', 'Results after one use'],
    ['RESULTS AFTER ONE WASH', 'Results after one wash'],
    ['RESULTS AFTER ONE TREATMENT', 'Results after one treatment'],
    ['WHY DENSITY-FOCUSED CARE STARTS AT THE SCALP', 'Why density-focused care starts at the scalp'],
    ['WHY SHAMPOO AND A SCALP RESET HAVE DIFFERENT JOBS', 'Why shampoo and a scalp reset have different jobs'],
    ['WHY SLIP MATTERS THROUGH THE LENGTHS', 'Why slip matters through the lengths'],
    ['WHEN REGULAR CONDITIONING ISN’T ENOUGH', 'When regular conditioning isn’t enough'],
    ['INGREDIENTS', 'Ingredients'],
    ['EXFOLIATION, WITH BALANCE BUILT IN.', 'Exfoliation, with balance built in.'],
    ['ROOT FOCUS + STRAND SUPPORT', 'Root focus + strand support'],
    ['THREE FORMS OF CONDITIONING SUPPORT', 'Three forms of conditioning support'],
    ['PROTEIN SUPPORT + RICH CONDITIONING', 'Protein support + rich conditioning'],
    ['SMOOTHING SUPPORT + LIGHT CONDITIONING', 'Smoothing support + light conditioning'],
    ['FOCUSED CARE, BY DESIGN.', 'Focused care, by design.'],
  ]);

  const productNameSelectors = [
    '.product-main__summary > h1',
    '.home-range h3',
    '.routine-expansion__card h3',
    '.collection-card h2 a',
    '.product-card__title a',
    '.seriva-cart-line h2 a',
  ].join(',');

  const headingSelectors = [
    '.seriva-proof__header h2',
    '.scalp-reset-proof__header h2',
    '.shampoo-proof__header h2',
    '.conditioner-proof__header h2',
    '.hair-mask-proof__header h2',
    '.leave-in-proof__header h2',
    '.seriva-education__header h2',
    '.scalp-reset-education__header h2',
    '.conditioner-education__header h2',
    '.hair-mask-education__header h2',
    '.seriva-formula__header h2',
    '.scalp-reset-formula__header h2',
    '.shampoo-formula__header h2',
    '.conditioner-formula__header h2',
    '.hair-mask-formula__header h2',
    '.leave-in-formula__header h2',
    '.seriva-brand-editorial__copy h2',
  ].join(',');

  const normalizePresentationCopy = (scope = document) => {
    scope.querySelectorAll?.(productNameSelectors).forEach((node) => {
      const replacement = productNamePresentation.get(node.textContent.trim());
      if (replacement) node.textContent = replacement;
    });

    scope.querySelectorAll?.(headingSelectors).forEach((node) => {
      const replacement = headingPresentation.get(node.textContent.trim());
      if (replacement) node.textContent = replacement;
    });

    if (targetScope !== 'serum') return;

    const scalpEducationHeading = scope.querySelector?.('.seriva-scalp-education__header h2');
    if (scalpEducationHeading && scalpEducationHeading.textContent.trim().toUpperCase() === 'SCALP CARE BEYOND THE FORMULA') {
      scalpEducationHeading.replaceChildren(
        document.createTextNode('Scalp care'),
        document.createElement('br'),
        document.createTextNode('Beyond the formula'),
      );
    }
  };

  const initialize = () => {
    normalizePresentationCopy();
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) normalizePresentationCopy(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
